<div class="caremoni-ui-theme" [attr.dpad]="DpadZoneType.SUB_HEADER"  y-dpad="0" x-dpad="0" (click)="toggleTheme($event)">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" stroke="currentColor" stroke-width="2" fill="none" />
    </svg>

    <span>ダークモード</span>
    <caremoni-switch-button
    index-ppad="2"
    [config]="switchButtonConfig"
    [checked]="isDarkMode"
    ></caremoni-switch-button>
</div>